import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { ROUTES } from "./constants";
import { protectedRoute } from "./helpers";

// Abacus Home
const AbacusHome = lazy(() => import("@/features/abacus"));

// Abacus Cost
const AbacusCostHomePage = lazy(
	() => import("@/features/abacus/cost/CostHomePage"),
);
const AbacusCostInputPage = lazy(
	() => import("@/features/abacus/cost/input/HomePage"),
);
const AbacusBenchmarkPage = lazy(
	() => import("@/features/abacus/cost/benchmark/BenchmarkContent"),
);
const AbacusSearchPage = lazy(
	() => import("@/features/abacus/cost/search/SearchPage"),
);

// Abacus Duration
const AbacusDurationHome = lazy(
	() => import("@/features/abacus/duration/DurationHomePage"),
);
const AbacusProductivityPage = lazy(
	() => import("@/features/abacus/duration/productivity/index"),
);
const AbacusProductivityDocumentView = lazy(
	() => import("@/features/abacus/duration/productivity/DocumentView"),
);
const AbacusDurationBenchmarkPage = lazy(
	() => import("@/features/abacus/duration/benchmarking/index"),
);
const AbacusDurationSearchPage = lazy(
	() => import("@/features/abacus/duration/search/SearchPage"),
);
const AbacusDurationInformationPage = lazy(
	() => import("@/features/abacus/duration/info/DurationInformationPage"),
);

export const abacusRoutes: RouteObject[] = [
	{
		path: ROUTES.ABACUS,
		element: protectedRoute(<AbacusHome />),
	},
	{
		path: ROUTES.ABACUS_COST,
		element: protectedRoute(<AbacusCostHomePage />),
	},
	{
		path: ROUTES.ABACUS_COST_INPUT,
		element: protectedRoute(<AbacusCostInputPage />),
	},
	{
		path: ROUTES.ABACUS_COST_BENCHMARK,
		element: protectedRoute(<AbacusBenchmarkPage />),
	},
	{
		path: ROUTES.ABACUS_COST_SEARCH,
		element: protectedRoute(<AbacusSearchPage />),
	},
	{
		path: ROUTES.ABACUS_DURATION,
		element: protectedRoute(<AbacusDurationHome />),
	},
	{
		path: ROUTES.ABACUS_DURATION_INPUT,
		element: protectedRoute(<AbacusDurationInformationPage />),
	},
	{
		path: ROUTES.ABACUS_DURATION_BENCHMARK,
		element: protectedRoute(<AbacusDurationBenchmarkPage />),
	},
	{
		path: ROUTES.ABACUS_DURATION_SEARCH,
		element: protectedRoute(<AbacusDurationSearchPage />),
	},
	{
		path: ROUTES.ABACUS_DURATION_PRODUCTIVITY,
		element: protectedRoute(<AbacusProductivityPage />),
	},
	{
		path: ROUTES.ABACUS_DURATION_PRODUCTIVITY_DOC,
		element: protectedRoute(<AbacusProductivityDocumentView />),
	},
];
